<rask-environment-ribbon></rask-environment-ribbon>
<header>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary page-nav" role="navigation">
    <button class="navbar-toggler" type="button"
      (click)="isSubmenuCollapsed = !isSubmenuCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>

    @if (isAuthenticated) {
      <rask-quick-search></rask-quick-search>
    }

    <div [ngbCollapse]="isSubmenuCollapsed" class="collapse navbar-collapse flex-wrap">
      <!-- Varumärke -->
      <a class="navbar-brand" aid="link-rask-start-sida" routerLink="/">RASK</a>

      @if (isAuthenticated) {
        <ul class="navbar-nav">
          @for (item of config.mainNodes; track item) {
            @if (showMenu(item) | async) {
              <li class="nav-item">
                <a class="nav-link" [attr.aid]="item.aid"
                  [class.active]="selectedMenuId === item.id"
                  (click)="selectMenu(item.id)"
                  translate="{{item.name}}">
                </a>
              </li>
            }
          }
        </ul>
      }

      <!-- Profilmeny -->
        <ul class="nav navbar-nav nav-sidebar justify-content-end dropdown ms-auto">
            <li class="nav-item">
              <div #profileMenuToggle class="dropdown-toggle profile-menu-dropdown">
                <a class="nav-link profile-link"
                    (click)="toggleProfileMenu()"
                    role="button">
                    <span class="profile-link-user">
                    <i class="fas fa-lg fa-user"></i>
                    <i class="ms-1 me-3 far fa-lg fa-angle-down"></i>
                    </span>
                </a>
              </div>
              <!-- Dropdown för profilmenyn -->
              <div [ngbCollapse]="isProfileMenuCollapsed" [animation]="false"
                class="dropdown-menu dropdown-menu-end" style="z-index: 10000;">
                @if (isAuthenticated) {
                    <a class="dropdown-item" translate="FUNCTIONS_HEADER"
                    routerLink="funktioner"></a>
                    <a class="dropdown-item" translate="ABOUT_HEADER"
                        *raskHasRole="['RASK.Titta']"
                    routerLink="about"></a>
                }
                <a class="dropdown-item" translate="LOGIN_LOGOUT" (click)="logout()"></a>
              </div>
            </li>
        </ul>

      <div id="flexBreak"></div>

      <!-- Underrad för navigering (Nivå 2) -->
      <div class="navbar-nav nav-submenu">
        @for (menu of config.mainNodes; track menu) {
          <div>
            @if (selectedMenuId === menu.id) {
              <ul class="nav-submenu-content">
                @for (item of menu.subMenuNodes; track item) {
                  @if (showMenu(item) | async) {
                    <li class="nav-item">
                      <a class="nav-link" [attr.aid]="item.aid"
                        routerLink="{{item.url}}"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? {exact: true}"
                        >
                        <span translate="{{item.name}}"></span>
                      </a>
                    </li>
                  }
                }
              </ul>
            }
          </div>
        }
      </div>
    </div>
  </nav>
  <rask-systemaktivitet-notis></rask-systemaktivitet-notis>
</header>

<!-- SVEASKOG LOGO FOR PRINT -->
<div class="logo-print">
  <img src="dist/img/sveaskog-logo-contrast.svg" alt="Sveaskog" height="30" />
</div>

<div class="main height-90">
  <div class="container-fluid full-height">
    <rask-breadcrumb-navigation></rask-breadcrumb-navigation>
    <div class="row full-height">
      <div class="col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<rask-busy></rask-busy>
<rask-toast></rask-toast>